// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import { applyAspectRatioBoxStyles, applyAspectRatioBoxInsideStyles } from '@tcp/core/src/utils';

export const StyledImageSection = styled.div`
  ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxStyles(props.aspectRatioObj, 'DESKTOP')}
  }
`;

export const StyledDamImage = styled(DamImage)`
  ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'DESKTOP')}
  }
`;
